<template>
	<div ref="pageWrapper" class="page-wrapper our-mission d-flex flex-column">
		<div class="background" style="background-position: 50% 100%">
			<TopNavigationV8 :page="routeName" @toggleNav="handleNav" />
			<div class="our-mission-help-anyone--bg landing-page-component" style="width: 100%; display: flex">
				<div class="our-mission-help-anyone header">
					<h3>Our Mission:</h3>
					<h3>
						We exist to help
						<span class="our-mission-help-anyone-tooltip">
							anyone
							<img src="/images/about/v6/icons/anyone.svg" alt="" class="our-mission-help-anyone-tooltip--img" />
						</span>
						work for themselves.
					</h3>
				</div>
			</div>
		</div>

		<div class="our-mission-message landing-page-component">
			<div class="our-mission-message-image">
				<div id="john"></div>
			</div>
			<div class="our-mission-message-text">
				<h3>A Message From Our Founder</h3>
				<p>As the only child of an immigrant single mother, I’ve been chasing meaning and fulfillment my entire career.</p>

				<p>
					While growing my first 10k followers on TikTok, I realized that I loved being my own boss, setting my own hours, and pursuing my
					own passion.
				</p>

				<p>But I also learned just how difficult it was to try to start a Creator business.</p>

				<p>There was no easy way to monetize my following, and I didn’t want to sellout to big brands.</p>

				<p>
					<span class="strong">And that’s why I started Stan.</span> Stan is the all-in-one, business-in-a-box I wish I had when I first
					started creating.
				</p>

				<p>
					We automate all of the ‘business stuff’ so that you can spend your time doing what you love - creating great content! We’re on a
					mission to empower anyone to make a living working for themselves and we’re grateful you’re here.
				</p>

				<p>Creating content is really hard. Stan is here to help you breathe just a little bit easier.</p>

				<p style="font-weight: 600; margin-bottom: 2px">Wishing you all the best,</p>
				<p style="font-weight: 600">John Hu (@jayhoovy)</p>
			</div>
		</div>

		<div v-if="isMobile" class="our-mission-our-values--bg landing-page-component">
			<div class="our-mission-our-values">
				<h3>Our Values</h3>
				<OurMissionBrainV6 v-if="isMobile" />
			</div>
		</div>

		<div v-if="!isMobile" class="our-mission-our-values--bg landing-page-component">
			<div class="our-mission-our-values">
				<h3>Our Values</h3>
				<OurMissionBrainV6 view="full" />
			</div>
		</div>

		<div class="section">
			<div class="title">
				<h3>Our Annual Shareholder Letters</h3>
			</div>

			<div class="articles">
				<a href="https://thecreatorentrepreneur.substack.com/p/stans-2023-shareholder-letter">
					<div class="article first">
						<img src="/images/home/v6/stan2023.webp" alt="Image" />

						<div class="expo">
							<h2>Stan's 2023 Shareholder Letter</h2>
							<p>How we grew 8.1x this year from $1.7M ARR to $14.7M ARR, our key risks, and the multi-billion $ opportunity ahead.</p>
						</div>
					</div>
				</a>
				<a href="https://thecreatorentrepreneur.substack.com/p/stans-2022-shareholder-letter-creators">
					<div class="article second">
						<img src="/images/home/v6/stan2022.webp" alt="Image" />

						<div class="expo">
							<h2>Stan's 2022 Shareholder Letter</h2>
							<p>
								How we grew from $0 to $1.7M ARR, why the Recession is actually a good thing for the Creator Economy, and how you can
								take advantage of the opportunity ahead.
							</p>
						</div>
					</div>
				</a>
			</div>
		</div>

		<div class="our-mission-try-stan">
			<h3>Try Stan for {{ trialDays || 14 }} Days Free</h3>
			<TrialButton where-am-i="about-page" :show-button-caption="false" />
		</div>

		<div class="our-mission-footer--bg">
			<FooterV8 id="footer" />
		</div>
	</div>
</template>

<script>
	import { defineComponent, getCurrentInstance, onMounted, onUnmounted, ref } from 'vue'
	import { useRoute } from 'vue-router'
	import OurMissionBrainV6 from './BrainV6'
	import TopNavigationV8 from '@/components/header/TopNavigationV8'
	import FooterV8 from '@/components/footer/FooterV8'
	import { getIsMobile } from '@/plugins/is'
	import TrialButton from '../shared/TrialButton.vue'
	import { useLandingPage } from '@/stores/landingPage'

	export default defineComponent({
		name: 'LandingPageV6',
		components: {
			OurMissionBrainV6,
			TopNavigationV8,
			FooterV8,
			TrialButton,
		},
		setup() {
			const {
				proxy: { $emitter },
			} = getCurrentInstance()
			const { name: routeName } = useRoute()
			const pageWrapper = ref(null)
			const isMobile = ref(getIsMobile())
			const lastScrollTop = ref(0)
			const isNavVisible = ref(false)
			const landingPage = useLandingPage()
			const trialDays = landingPage.trialDays
			const emit = ev => {
				$emitter.emit(ev)
			}

			function resizePage(ev) {
				isMobile.value = getIsMobile()
			}

			function handleScroll() {
				const st = window.pageYOffset || document.documentElement.scrollTop
				if (st > lastScrollTop.value) {
					document.body.classList.remove('scroll-up')
					document.body.classList.add('scroll-down')
					document.body.style.backgroundColor = '#F2F4F8 !important'
				} else if (st < lastScrollTop.value) {
					document.body.classList.remove('scroll-down')
					document.body.classList.add('scroll-up')
					document.body.style.backgroundColor = '#F2F4F8'
				}
				lastScrollTop.value = st
			}
			function handleNav(navVisible) {
				isNavVisible.value = navVisible
			}
			onMounted(() => {
				window.addEventListener('resize', resizePage, false)
				document.addEventListener('scroll', handleScroll, false)
			})

			onUnmounted(() => {
				window.removeEventListener('resize', resizePage, false)
				document.removeEventListener('scroll', handleScroll, false)
			})

			return {
				trialDays,
				pageWrapper,
				routeName,
				isMobile,
				emit,
				handleNav,
				isNavVisible,
			}
		},
	})
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/helpers-v6.scss';

	$help-anyone-background: var(--stan-about-help-anyone-background, #000000);

	.h-auto {
		height: auto;
	}

	:deep(.navbtn){
		display: none;
	}

	:deep(.pricing){
		display: none;
	}


	body {
		background-color: black !important;
	}

	.scroll-up {
		background-color: black !important;
	}

	.scroll-down {
		background-color: black !important;
	}

	* {
		--text-dark-color: #131f60;
		--text-paragraph-color: #808eb6;
		--about-primary-color: #f9f9f9;
		--stan-about-message-background: #ffffff;
		--stan-about-our-values-background: #f9f9ff;
		--stan-about-try-stan-background: #ffffff;
	}
	.our-mission-nav {
		@media screen and (max-height: 767px) {
			position: fixed;
			height: 100vh;
		}
	}

	.our-mission-nav.open {
		position: fixed; /* Fix the navigation to the viewport */
		top: 0;
		left: 0;
		width: 100vw; /* Full width of the viewport */
		height: 100vh; /* Full height of the viewport */
		z-index: 1000; /* Higher than other elements */
		background-color: rgba(0, 0, 0, 0.8); /* Optional: Add a background color if needed */
		display: flex;
		align-items: center;
		justify-content: center; /* Adjust as needed */
	}

	.background {
		background: linear-gradient(0deg, rgba(black, 0.6), rgba(black, 0.6)), url('/public/images/home/v6/stan-team-2.webp');
		justify-content: center;
		align-items: center;
		background-size: cover;
		background-attachment: fixed;
		background-position: 50% 100%;
		height: 85vh;
		width: 100vw;
		max-width: 100%;
		position: relative;
		left: 0;
		top: 0;
		z-index: 3;
	}

	.section {
		display: flex;
		flex-direction: column;
		align-items: center;
		.title {
			width: 90%;

			h3 {
				font-family: Plus Jakarta Sans, sans-serif;
				font-style: normal;
				font-weight: 800;
				font-size: 40px;
				line-height: 100%;
				letter-spacing: -0.01em;
				text-align: center;
				color: var(--text-dark-color);
				margin-bottom: 90px;
			}

			@media screen and (max-width: $primary-mobile-breakpoint-px) {
				h3 {
					margin-bottom: 0;
					font-size: 32px;
				}
			}
		}

		.articles {
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 40px;

			.first {
				background: #f9f8fd;
			}

			.second {
				background: #5925f2;
			}

			.article {
				width: 400px;
				height: 400px;
				border: 2px solid red;
				box-shadow: 0 20px 60px rgba(#00106d, 0.1);
				padding: 0px;
				border-radius: 15px;
				transition: 0.2s ease;
				border: 1px solid rgba(#00106d, 0.15);
				position: relative;
				cursor: pointer;

				img {
					width: 100%;
					border-radius: 8px;
					transition: 0.2s ease;
				}

				.expo {
					display: flex;
					flex-direction: column;
					justify-content: flex-end;

					position: absolute;
					left: 0;
					bottom: 0;

					padding: 20px;
					height: 200px;

					background-image: linear-gradient(to bottom, rgba(black, 0), rgba(black, 1));
				}
				h2 {
					font-family: Inter, sans-serif;
					font-size: 18px;
					font-weight: 600;
					letter-spacing: -0.2px;
					margin: 20px 0 10px 0;
					color: white;
				}
				p {
					font-family: Inter, sans-serif;
					font-size: 13px;
					font-weight: 300;
					line-height: 130%;
					letter-spacing: -0.1px;
					color: rgba(white, 0.6);
					margin-bottom: 10px;
					transition: 0.2s ease;
				}
				&:hover {
					img {
						transform: scale(0.95);
					}
					p {
						margin-bottom: 20px;
					}
				}
			}
			@media screen and (max-width: $primary-mobile-breakpoint-px) {
				width: 100vw;
				flex-direction: column;
				align-items: center;
				.article {
					width: calc(90vw - 20px);
				}
			}
		}
	}

	div {
		overflow-y: hidden !important;
		overflow-x: hidden !important;
	}

	.our-mission {
		&.page-wrapper {
			background-image: linear-gradient(180deg, $help-anyone-background 0% 10%, #ffffff 10% 90%);
		}

		&-help-anyone,
		&-message,
		&-our-values,
		&-try-stan {
			margin: auto;
		}

		&-top-navigation--bg {
			background-color: none;
		}
		&-footer--bg {
			background-color: var(--stan-footer-panel-section-background, #000000);
		}

		.header {
			position: absolute;
			width: 100vw;
			left: 0;
			bottom: 20vh;
		}

		@media screen and (max-width: $primary-mobile-breakpoint-px) {
			.header {
				bottom: 0 !important;
			}
		}

		&-help-anyone {
			overflow: visible !important;

			@media screen and (max-width: $primary-mobile-breakpoint-px) {
				padding-top: 15vh !important;
				padding-bottom: 30vh !important;
			}

			&--bg {
				@media screen and (max-width: $primary-mobile-breakpoint-px) {
				}
			}

			h3 {
				font-family: Plus Jakarta Sans, sans-serif;
				font-style: normal;
				color: var(--about-primary-color);
				font-weight: 700;
				font-size: 44px;
				line-height: 110%;
				letter-spacing: -0.3px;
				margin-bottom: 15px;
				text-align: center;
				text-shadow: 0 15px 50px black, 0 15px 50px black, 0 15px 50px black;
			}

			p {
				font-family: 'Inter', sans-serif;
				opacity: 0.8;
				font-weight: 300;
				font-size: 16px;
				line-height: 140%;
				letter-spacing: -0.02em;
				color: var(--about-primary-color);
				margin-top: 0;
				margin-bottom: 1.6rem;
				width: 100%;
			}

			&-tooltip {
				position: relative;
				display: inline-block;
				&--img {
					position: absolute;
					z-index: 1;
					width: 99%;
					top: 52px;
					left: 0px;
				}
			}

			@media (max-width: $primary-mobile-breakpoint-px) {
				padding: 11px 28px 39px;
				&--bg {
					padding-top: 100px;
				}
				h3 {
					font-weight: 800;
					font-size: 28px;
					line-height: 110%;
					letter-spacing: -0.01em;
				}
				p {
					font-size: 14px;
					line-height: 140%;
					letter-spacing: -0.015em;
					opacity: 0.8;
					margin-bottom: 1.2rem;
				}
				&-tooltip {
					&--img {
						top: 31px;
						left: 2px;
						width: 95%;
					}
				}
			}
		}

		&-message {
			background-color: var(--stan-about-message-background, #ffffff);
			display: grid !important;
			grid-template-columns: 20% auto;
			grid-gap: 4%;
			grid-template-columns: 20% auto;
			grid-gap: 4%;

			padding: 50px;
			padding-top: 70px;

			&-image {
				overflow: visible !important;
				#john {
					width: 100%;
					box-shadow: 0px 20px 50px rgba(black, 0.3);
					aspect-ratio: 1;

					@supports not (aspect-ratio: 1) {
						height: 0;
						padding-top: 100%;
					}
					background-image: url('/public/images/home/v6/john_hu.webp');
					background-size: cover;
					box-shadow: 0px 20px 50px rgba(black, 0.1);
					border-radius: 50vw;
					@media (max-width: $primary-mobile-breakpoint-px) {
						margin-top: 20px;
					}
				}
				@media (max-width: $primary-mobile-breakpoint-px) {
					border-radius: 500px;
				}
			}

			&-text {
				h3 {
					font-family: Plus Jakarta Sans, sans-serif;
					font-style: normal;
					font-weight: 800;
					font-size: 32px;
					line-height: 100%;
					letter-spacing: -0.1px;
					color: var(--text-dark-color);
					margin-bottom: 39px;
				}
				p {
					font-family: 'Inter', sans-serif;
					font-style: normal;
					font-weight: 300;
					font-size: 15px;
					line-height: 140%;
					letter-spacing: -0.25px;
					color: var(--text-dark-color);
					width: 90%;
					margin-bottom: 28px;
					&.strong {
						font-weight: 700;
					}
				}
			}
			@media (max-width: $primary-mobile-breakpoint-px) {
				padding: 20px 30px 50px 30px;
				grid-template-columns: 1fr;
				grid-gap: 3.2%;
				width: 100%;
				margin: auto;
				&-text {
					padding-left: 4px;
					padding-bottom: 40px;
					h3 {
						font-size: 28px;
						line-height: 110%;
						margin-bottom: 25px;
					}

					p {
						font-size: 14px;
						letter-spacing: -0.009em;
						width: 98%;
						margin-bottom: 19px;
					}
				}
				span.strong {
					font-weight: 700;
				}
			}
		}

		&-our-values {
			display: flex;
			flex-direction: column !important;
			align-items: center;

			@media (max-width: $primary-mobile-breakpoint-px) {
				&--bg {
					> div {
						h3 {
							margin-bottom: 16px;
						}
					}
					& + div {
						> div {
							padding-top: 36px;
							padding-bottom: 36px;
							align-items: flex-start;
							background-color: #ffffff;
						}
					}
				}
			}
			padding-top: 50px;
			padding-bottom: 109px;

			h3 {
				font-family: Plus Jakarta Sans, sans-serif;
				font-style: normal;
				font-weight: 800;
				font-size: 40px;
				line-height: 100%;
				letter-spacing: -0.01em;
				text-align: center;
				color: var(--text-dark-color);
				margin-bottom: 40px;
			}

			@media (max-width: $primary-mobile-breakpoint-px) {
				padding-left: 0;
				padding-right: 0;
				padding-top: 0;
				padding-bottom: 30px;
				h3 {
					font-size: 32px;
					line-height: 40px;
				}
			}
		}

		&-try-stan {
			display: flex;
			flex-direction: column !important;
			align-items: center;
			background-color: var(--stan-about-try-stan-background, #ffffff);
			padding-top: 140px;
			padding-bottom: 140px;
			overflow: visible !important;

			h3,
			button.panel-button {
				font-family: Plus Jakarta Sans, sans-serif;
				font-style: normal;
			}

			h3 {
				font-size: 36px;
				font-weight: 800;
				line-height: 100%;
				letter-spacing: 0.01em;
				text-align: center;
				color: var(--text-dark-color);
				margin-bottom: 50px;
				padding-left: 2px;

				@media (max-width: $primary-mobile-breakpoint-px) {
					font-size: 24px;
					line-height: 105%;
					text-align: center;
					letter-spacing: 0.005em;
				}
			}

			.panel-button {
				width: 100%;
				height: 80px;
				border: none;
				background: #00106d;
				box-shadow: 0px 10px 30px rgba(0, 16, 109, 0.2);
				border-radius: 50px;
				transition: 0.2s ease;
				&:hover {
					background: #090e2a;
				}
				&-content {
					padding: 16px 16px 24px 16px;

					&--text {
						font-size: 24px;
						font-weight: 700;
						color: #ffffff;
						line-height: 105%;
						transform: translateY(2px);
						overflow: visible !important;
					}
				}
				@media (max-width: $primary-mobile-breakpoint-px) {
					height: 60px;
					&-content {
						&--text {
							font-size: 18px;
						}
					}
				}
			}

			@media (max-width: $primary-mobile-breakpoint-px) {
				padding-bottom: 150px;
				width: 80%;

				h3 {
					font-size: 24px;
					line-height: 105%;
					letter-spacing: 0.005em;
				}
			}
		}
	}
</style>
